/**
 * TrackerPill — one tracker's pill in ProviderFilter: its ProviderBadge as a
 * toggle, solid while that tracker is the picked one.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { ProviderBadge, type BadgeProvider } from '@/components/ui/ProviderBadge';

interface Props {
  provider: BadgeProvider;
  on: boolean;
  onClick: () => void;
}

export const TrackerPill: FC<Props> = ({ provider, on, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={on}
    aria-label={`Show ${provider} only`}
    className="inline-flex rounded transition-opacity hover:opacity-100 aria-[pressed=false]:opacity-70"
  >
    <ProviderBadge provider={provider} solid={on} />
  </button>
);

export default TrackerPill;
